import { Box, Button, Grid, Stack, Typography } from "@mui/material";

import React from "react";

import { yellow } from "@mui/material/colors";
import DescriptionIcon from "@mui/icons-material/Description";
import RichTextEditor from "components/atoms/richTextEditor/RichTextEditor";
import VoiceNotePlayBack from "components/atoms/voiceNotePlayback";
import moment from "moment";
function ModalContent({ handleClose, item }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        p: 2,
        width: "100%",
      }}
    >
      <Stack direction={"row"} spacing={1} alignItems={"center"} sx={{ my: 2 }}>
        <DescriptionIcon sx={{ color: yellow[800] }} />
        <Typography
          sx={{ fontWeight: 700, color: "secondary.main", fontSize: "18px" }}
          className="assesment_report_title"
        >
          Doctors note on -{" "}
          {moment(new Date(item?.updatedAt)).format("MMM Do, YYYY : hh:mm a")}
        </Typography>
      </Stack>
      {item?.note?.history && (
        <RichTextEditor
          readOnly
          value={item?.note?.history}
          title={"History"}
          className="assesment_report_message"
        />
      )}
      {item?.note?.examination && (
        <RichTextEditor
          readOnly
          value={item?.note?.examination}
          title={"Examination"}
          className="assesment_report_message"
        />
      )}
      {item?.note?.findings && (
        <RichTextEditor
          readOnly
          value={item?.note?.findings}
          title={"Findings"}
          className="assesment_report_message"
        />
      )}
      {item?.note?.diagnosis && (
        <RichTextEditor
          readOnly
          value={item?.note?.diagnosis}
          title={"Diagnosis"}
          className="assesment_report_message"
        />
      )}
      {item?.note?.plan && (
        <RichTextEditor
          readOnly
          value={item?.note?.plan}
          title={"Plan"}
          className="assesment_report_message"
        />
      )}

      <Stack direction={"column"} spacing={2}>
        <Typography
          sx={{
            fontWeight: "700",
            color: "primary.formLabel",
            fontSize: "14px",
          }}
        >
          Voice notes
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {item?.voiceNotes?.map((audio) => (
            <Grid item xs={12} sm={6} key={audio}>
              <VoiceNotePlayBack audioUrl={audio} />
            </Grid>
          ))}
        </Grid>
      </Stack>
      <Button
        variant="outlined"
        sx={{
          mt: 2,
          alignSelf: "start",
          border: "1px solid rgba(0,0,0,0.3)",
          color: "primary.main",
          width: "30%",
        }}
        onClick={handleClose}
      >
        Close
      </Button>
    </Box>
  );
}

export default ModalContent;
